import { Injectable } from '@angular/core';
import { FilterParams } from '@claranet/node-search-filter';
import { Observable } from 'rxjs';
import { ListMetadataKeys } from '@data/models/metadata.model';
import { toParams } from '@shared/utils/query-to-params';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Error, ErrorService } from '@app/services/error.service';

@Injectable({providedIn: 'root'})
export class MetadataService {
    constructor(
        private errorService: ErrorService,
        private http: HttpClient,
    ) { }

    public fetchMetadataKeys(apiRoute: string, filterParams: FilterParams, errors: Error[]): Observable<ListMetadataKeys> {
        const params = toParams(filterParams);
        return this.http.get<{ metadataKeys: ListMetadataKeys }>(apiRoute + '/metadata-keys', {params}).pipe(
            map((result) => result.metadataKeys),
            catchError(this.errorService.errorHandler<ListMetadataKeys>(errors, 'Récupération des clés de metadata', []))
        );
    }
}
